import axiosClient from "utils/api";

const URI = "admin/staticPage/getAll";

export const getPrivacyPolicy = async (payload) => {
  const URL = `${URI}/${payload.type}`;
  try {
    const response = await axiosClient().request({
      url: URL,
      method: "get",
    });
    return response.data;
  } catch (error) {
    console.error("Error occurred Get Static Pages:", error);
    throw error;
  }
};